import type {
  SearchAutoCompleteQueryVariables,
  SearchKeywordQueryVariables,
  SearchMainQueryVariables,
  SearchThemeKeywordQueryVariables,
  ShortcutListQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Search 도메인 Query Key 관리
 *
 * 기존 GraphQL generated types의 getKey 로직을 그대로 재사용
 */
export const SEARCH_QUERY_KEY_MAP = {
  /**
   * 검색 자동완성
   * Origin: useSearchAutoCompleteQuery.getKey
   */
  searchAutoComplete: (variables: SearchAutoCompleteQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'searchAutoComplete', variables] as const,

  /**
   * 검색 메인 (인기 검색어)
   * Origin: useSearchMainQuery.getKey
   */
  searchMain: (variables?: SearchMainQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'searchMain'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'searchMain', variables] as const),

  /**
   * 검색 키워드 결과 (Infinite)
   * Origin: useInfiniteSearchKeywordQuery.getKey
   */
  infiniteSearchKeyword: (variables: SearchKeywordQueryVariables) => [
    ADAPTER_QUERY_KEY_PREFIX,
    'searchKeyword.infinite',
    variables,
  ],

  /**
   * 테마 검색 키워드 결과 (Infinite)
   * Origin: useInfiniteSearchThemeKeywordQuery.getKey
   */
  infiniteSearchThemeKeyword: (variables: SearchThemeKeywordQueryVariables) => [
    ADAPTER_QUERY_KEY_PREFIX,
    'searchThemeKeyword.infinite',
    variables,
  ],

  /**
   * 바로가기 목록
   * Origin: useShortcutListQuery.getKey
   */
  shortcutList: (variables?: ShortcutListQueryVariables) =>
    variables === undefined ? ['shortcutList'] : ['shortcutList', variables],
} as const;
